import React from 'react';
import SubmissionDetails from '../../../SubmissionDetails';
import { DetailsProps } from '../types';

import s from './Poll.scss';

export const PollDetails: React.FC<DetailsProps> = ({ deviation: { poll }, deviation }) => {
  if (!poll) {
    return null;
  }
  return (
    <div className={s['root']}>
      <SubmissionDetails deviation={deviation} className={s['details']} />
    </div>
  );
};
PollDetails.displayName = 'PollDetails';

export default PollDetails;
